

import {GET_FillAdminExamcodes} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminExamCodes: null
 
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillAdminExamcodes:
            return {
                AdminExamCodes: action.body
              
              
            }
           

        default:
            return state;
    }
}